import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import StrongCTA from "../components/home/StrongCTA";
import { SERVICES } from "../data/services";

export default function ServiciosPage() {
  useEffect(() => {
    document.title = "Servicios | Ospino & Piñeres Abogados";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="pt-36 pb-16 md:pt-44 md:pb-20 bg-white border-b border-slate-100">
        <div className="container-x">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-rule" />
              <span className="overline">Áreas de práctica</span>
            </div>
            <h1 className="font-serif text-navy-900 text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">
              Asesoría jurídica y contable <em className="italic" style={{ color: "#C5A059" }}>especializada</em>, con enfoque estratégico y cobertura nacional.
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              Conoce nuestras 13 áreas de práctica. Cada servicio combina experiencia técnica, mirada multidisciplinaria y acompañamiento personalizado.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section-pad" style={{ background: "#F8F9FA" }}>
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
            {SERVICES.map((s, i) => {
              const Icon = s.icon;
              return (
                <Reveal key={s.slug} delay={i * 30}>
                  <Link
                    to={`/servicios/${s.slug}`}
                    data-testid={`services-card-${s.slug}`}
                    className="group bg-white p-8 h-full flex flex-col transition-all duration-300 hover:bg-navy-900"
                  >
                    <Icon size={28} strokeWidth={1.4} style={{ color: "#C5A059" }} className="mb-5" />
                    <h3 className="font-serif text-xl text-navy-900 group-hover:text-white transition-colors leading-snug">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-sm text-slate-500 group-hover:text-slate-300 transition-colors leading-relaxed flex-1">
                      {s.short}
                    </p>
                    <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-slate-400 group-hover:text-gold transition-colors">
                      Ver detalle
                      <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <StrongCTA />
    </>
  );
}